import {
  getStatus,
  getIconType,
  getImportance,
  getSolvability,
} from '../../constants/seoMappings';

/**
 * Generates message for mobile friendliness section
 * @param {Object} data - The mobile friendliness data object
 * @returns {string|null} - Message for empty state or null if data exists
 */
const generateMessage = (data) => {
  const mobileFriendliness = data?.mobileFriendliness;
  if (mobileFriendliness === undefined || mobileFriendliness === null) {
    return 'This web page is not optimized for Mobile Visitors.';
  }
  return null;
};

/**
 * Transforms the mobile_friendliness criteria from WooRank API response
 * @param {Object} mobileFriendlinessCriteria - The mobile_friendliness criteria object from the API
 * @returns {Object} - Transformed mobile friendliness data for React components
 */
export const transformMobileFriendliness = (mobileFriendlinessCriteria) => {
  // Handle missing criteria - use 'neutral' status (maps to 'info' icon)
  if (!mobileFriendlinessCriteria) {
    return {
      status: getStatus('neutral'),
      iconType: getIconType('neutral'),
      importance: { level: 0, text: '' },
      solvability: { level: 0, text: '' },
      isEmpty: true,
      message: 'This web page is not optimized for Mobile Visitors.',
      data: null,
    };
  }

  const data = mobileFriendlinessCriteria?.data || {};
  const wooRankStatus = mobileFriendlinessCriteria?.status || 'neutral';
  const importance = mobileFriendlinessCriteria?.importance || 0;
  const solvability = mobileFriendlinessCriteria?.solvability || 0;

  const mobileFriendliness = data?.mobileFriendliness;
  const isEmpty = mobileFriendliness === undefined || mobileFriendliness === null;

  // Calculate percentage (API returns decimal 0-1, multiply by 100 for percentage)
  const percentage = isEmpty ? 0 : Math.round((mobileFriendliness ?? 0) * 100);

  return {
    status: getStatus(wooRankStatus),
    iconType: getIconType(wooRankStatus),
    importance: getImportance(importance),
    solvability: getSolvability(solvability),
    isEmpty,
    message: generateMessage(data),
    data: isEmpty ? null : {
      percentage,
      raw: mobileFriendliness,
    },
  };
};

export default transformMobileFriendliness;

